import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import Disabled from "components/common/Disabled";
import {
  PUNI_BROKER_API_NAME,
  sortBrokerList,
  useGetSortedBrokerList,
  useGetSortedBrokerListWithRefresh,
} from "components/inputs/program/BrokerSupport";
import * as labels from "config.labels";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import { useListBrokersQuery } from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const PuniBrokerCreation = ({ onCreate, onClose }) => {
  const brokers = useGetSortedBrokerList(PUNI_BROKER_API_NAME);

  const [createBroker] = staticDataService.useCreatePuniBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<BrokerCreation>"}
      formId={"puni-broker-creation-form"}
      title={"Add a new puni broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const PuniBroker = () => {
  const dispatch = useDispatch();

  const broker = useSelector(peopleSelectors.selectPuniBroker);

  const updateBroker = (value) => {
    dispatch(peopleActions.updatePuniBroker(value));
  };
  const { data: brokers } = useListBrokersQuery();
  const sortedBrokers = sortBrokerList(brokers);
  const [
    sortedPuniBrokers,
    refreshPuniBrokers,
  ] = useGetSortedBrokerListWithRefresh(PUNI_BROKER_API_NAME);

  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  return (
    <Disabled ifReadOnly>
      <PersonSelect
        person={broker}
        personList={[...sortedPuniBrokers, ...sortedBrokers]}
        onUpdatePerson={updateBroker}
        onUpdatePersonList={refreshPuniBrokers}
        PersonCreationComponent={PuniBrokerCreation}
        label={translateLabel(labels.PUNI_BROKER, {
          default: "Puni Broker",
        })}
        showLabelOnCard
      />
    </Disabled>
  );
};

export default PuniBroker;
